
import React, {Component} from 'react'
import CdnImage from '../../components/cdnImage/cdnImage.js'
import PageBarView from './PageBarView.js'
import DockBarView from './DockBarView.js'
import SelectionView from '../../components/selectionView/SelectionView.js'
import { Button } from 'reactstrap';


const themeUtil = require('../../utils/view/themeUtil.js');
const configurationManager = require('../../utils/config/configurationManager.js');
const translator = require('../../utils/translator/translator.js');
const stateManager = require('../../utils/state/stateManager.js');
const navigationPageAction = require('../../utils/state/actions/views/navigationPage/navigationPageAction.js');
const layoutCurrentPageIndexAction = require('../../utils/state/actions/views/layout/layoutCurrentPageIndexAction.js');
const designerConstants = require('./constants.js');
const navigationButtonsIds = require('../Navigation/navigationButtonsIds.js');
const displaySettingsUtils = require('../../utils/domain/settings/displaySettingsUtils.js');
const viewUtil = require('../../utils/view/viewUtil.js');

class NavigationView extends Component 
{
    constructor(props)
    {
        super(props);

        this.onAddButton = this.onAddButton.bind(this);
        this.onDeleteButton = this.onDeleteButton.bind(this);
        this.onDragEnd = this.onDragEnd.bind(this);

        this.state = {};
        this.state.designerContext = {};
        this.state.designerContext.pages = JSON.parse(JSON.stringify(themeUtil.getResolvedPages()));

        for (var index = 0; index < 10; index++)
        {
            let page = {};
            page.buttons = [];
            this.state.designerContext.pages.push(page);
        }

        this.state.designerContext.dockBar = JSON.parse(JSON.stringify(themeUtil.getResolvedDockBar()));
        this.state.designerContext.currentPageIndex = 0;

        this.state.newButtonDroppableId = null;
        this.state.showNewButtonDialogue = false;
    }

    render()
    {
        return <div className='h-100' key={Date.now().toString()}>
                    
                    {this.renderCancelButton()}
                    {this.renderSaveButton()}

                    <div style={{position:'fixed', top:'50%', left:'50%', transform:'translate(-50%, -50%)'}}>
                            {this.renderSystemLogo()}
                            <PageBarView onAdd={this.onAddButton} onDelete={this.onDeleteButton} 
                                         onDragEnd={this.onDragEnd} context={this.state.designerContext}/>
                    </div>
                    
                    <div style={{position:'fixed', bottom:0, width:'100%'}}>
                        <div style={{background:'#FFFFFF', paddingTop:'30px', paddingBottom:'20px', borderTop:'1px solid #05149e'}}>
                            <DockBarView onAdd={this.onAddButton} onDelete={this.onDeleteButton} 
                                            onDragEnd={this.onDragEnd} context={this.state.designerContext}/>
                        </div>
                    </div>
                    {this.renderNewButtonDialogue()}
                </div>
    }

    renderSystemLogo()
    {
        var cloudName = configurationManager.getConfig().cdnAppCloudName;
        return <div style={{marginBottom:'40px'}}>
                    <CdnImage cloudName={cloudName} height={Math.round(window.innerHeight * 0.25)} publicId={themeUtil.getResolvedLogo()}/>
                </div>
    }

    onDragEnd(result)
    {
        if (result.source == null || result.source.index == null ||
            result.destination == null || result.destination.index == null)
            return;

        let pages = this.state.designerContext.pages;
        let currentPage = pages[this.state.designerContext.currentPageIndex];
        
        let sourceIndex = result.source.index;
        let destinationIndex = result.destination.index;

        if (result.source.droppableId == designerConstants.pageBarDroppableId)
        {
            if (sourceIndex >= currentPage.buttons.length || destinationIndex >= currentPage.buttons.length)
                return;

            let sourceButton = currentPage.buttons[sourceIndex];

            if (result.destination.droppableId == designerConstants.pageBarDroppableId)
            {
                currentPage.buttons.splice(sourceIndex, 1);
                currentPage.buttons.splice(destinationIndex, 0, sourceButton);
                this.setState({});
                return;                
            }
        }

        if (result.source.droppableId == designerConstants.dockBarDroppableId)
        {
            if (sourceIndex >= this.state.designerContext.dockBar.length || destinationIndex >= this.state.designerContext.dockBar.length)
                return;
            
            let sourceButton = this.state.designerContext.dockBar[sourceIndex];
            
            if (result.destination.droppableId == designerConstants.dockBarDroppableId)
            {
                
                this.state.designerContext.dockBar.splice(sourceIndex, 1);
                this.state.designerContext.dockBar.splice(destinationIndex, 0, sourceButton);
                this.setState({});
                return;
            }
        }

    }

    renderCancelButton()
    {
        return <div style={{position:'fixed', top:'20px', left:"0", textAlign:'end', marginLeft:'20px'}}>
                    <Button className="btn-cancel"
                            onClick={()=>
                            {
                                stateManager.getStore().dispatch(navigationPageAction.createAction(null));
                            }}
                    >
                        {translator.getLabel("cancel")}
                    </Button>
                </div>
    }

    renderSaveButton()
    {
        return <div style={{position:'fixed', top:'20px', right:"0", textAlign:'end', marginRight:'20px'}}>
                    <Button className="btn-ok"
                            onClick={()=>
                            {
                                let newTheme = {};
                                newTheme.pages = [];
                                newTheme.dockBar = [];

                                this.state.designerContext.pages.forEach (existingPage =>
                                {
                                    let page = {};
                                    page.buttons = [];
                                    
                                    existingPage.buttons.forEach (existingButton =>
                                    {
                                        if (existingButton != navigationButtonsIds.blank)
                                            page.buttons.push(existingButton)    
                                    });

                                    if (page.buttons.length > 0)
                                    {
                                        page.caption = `Page.${newTheme.pages.length}`
                                        newTheme.pages.push(page);
                                    }
                                });

                                this.state.designerContext.dockBar.forEach (existingButton =>
                                {
                                    if (existingButton != navigationButtonsIds.blank)
                                        newTheme.dockBar.push(existingButton)   
                                });

                                if (newTheme.pages.length <= 0 || newTheme.dockBar.length <= 0)
                                {
                                    viewUtil.showErrorAlert("Layout must have at least one page and one dockbar button");
                                    return;
                                }
                                
                                displaySettingsUtils.setDisplayLayoutTheme(newTheme);
                                stateManager.getStore().dispatch(layoutCurrentPageIndexAction.createAction(0));
                                stateManager.getStore().dispatch(navigationPageAction.createAction(null));

                            }}
                    >
                        {translator.getLabel("save")}
                    </Button>
               </div>
    }

    onDeleteButton(index, droppableId)
    {
        if (droppableId == "pageBarButtonDroppables")
        {
            let pages = this.state.designerContext.pages;
            let currentPage = pages[this.state.designerContext.currentPageIndex];

            currentPage.buttons.splice(index, 1);
            this.setState({});
        }
        else
        {
            this.state.designerContext.dockBar.splice(index, 1);
            this.setState({});
        }
    }

    onAddButton(droppableId)
    {
        this.state.newButtonDroppableId = droppableId
        this.state.showNewButtonDialogue = true;
        this.setState({});
        
    }

    renderNewButtonDialogue()
    {
        if (!this.state.showNewButtonDialogue)
            return null;

        let selections = [];

        themeUtil.systemTheme.buttons.forEach (systemButton =>
        {
            let selection = {};
            selection.caption = translator.getLabel(systemButton);
            selection.id = systemButton;
            selections.push(selection);    
        })

        return <SelectionView selections={selections} caption={translator.getLabel("options")}
                onClose={()=>
                {
                    this.state.showNewButtonDialogue = false;
                    this.state.newButtonDroppableId = null;
                    this.setState({});
                }}
                onSelection={(selection)=>
                {
                    if (this.state.newButtonDroppableId == designerConstants.pageBarDroppableId)
                    {
                        let pages = this.state.designerContext.pages;
                        let pageIndex = this.state.designerContext.currentPageIndex;
                        let page = pages[pageIndex];
                        page.buttons.push(selection.id);
                    }
                    else
                    {
                        this.state.designerContext.dockBar.push(selection.id)
                    }

                    this.state.showNewButtonDialogue = false;
                    this.state.newButtonDroppableId = null;
                    this.setState({});
                }}/>
    }

}



export default NavigationView
